module.exports = __webpack_public_path__ + "img/21.253fe2c4.png";